import React from "react";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function SFAlert({
  children,
  title,
  icon,
}: {
  children: React.ReactNode;
  title: string;
  icon?: React.ReactNode;
}) {
  const theme = useTheme();
  return (
    <Box
      borderRadius={2}
      border={`1px solid ${theme.palette.primary.main}`}
      overflow="hidden"
    >
      {/* Header */}
      <Stack
        py={1.5}
        component="header"
        bgcolor={theme.palette.primary.main}
        px={2.5}
        direction="row"
        justifyContent="space-between"
        alignItems='center'
      >
        <Typography variant="subtitle2" fontWeight={700} color="white">
          {title}
        </Typography>
        {icon ? icon : <Box />}
      </Stack>
      {/* Body */}
      {children}
    </Box>
  );
}
